
import FileMeta from './file-meta.vue';
// import { fmtSeconds } from '@com/utils/data-format'
import AudioController from './audio-controller.vue';
import Aplayer from 'vue-aplayer';

// let canupdate = true
export default {
  props: {
    url: {
      type: String,
      default: ''
    },

    fileMeta: {
      type: Object
    },

    audioStyle: {
      type: Object
    },

    fileMetaStyle: {
      type: Object
    },

    autoPlayWhenHover: {
      type: Boolean,
      default: false
    },

    audioControls: {
      type: Boolean,
      default: false
    },

    audioOnlyLogo: {
      type: Boolean,
      default: false
    }
  },

  components: {
    FileMeta: FileMeta, AudioController: AudioController, Aplayer: Aplayer
  },

  data: function data() {
    return {
      hoverStatus: false,
      audioSlider: 0,
      duration: 0,
      playing: false
    };
  },


  computed: {
    audioPlayer: function audioPlayer() {
      return this.$refs.audioPlayer;
    },
    playerAttrs: function playerAttrs() {
      return {
        class: 'audio-player',
        mini: true,
        music: {
          src: this.url
        }
      };
    }
  },

  mounted: function mounted() {},


  methods: {
    handleTimeUpdate: function handleTimeUpdate(e) {
      this.$emit('time-update', this.$refs.audioPlayer.audio);
    },
    handleMouseEnter: function handleMouseEnter() {
      var _this = this;

      this.hoverStatus = true;
      // 时延一秒，如果还处于获取焦点的状态，再showPlayer
      setTimeout(function () {
        if (_this.hoverStatus) {
          _this.autoPlayWhenHover && _this.play();
        }
      }, 500);
    },
    handleMouseLeave: function handleMouseLeave() {
      this.hoverStatus = false;
      this.autoPlayWhenHover && this.pause();
    },
    play: function play() {
      this.$refs.audioPlayer && this.$refs.audioPlayer.play();
    },
    pause: function pause() {
      this.$refs.audioPlayer && this.$refs.audioPlayer.pause();
    }
  }
};